import { render, staticRenderFns } from "./ProductsDialog.vue?vue&type=template&id=9c25489c"
import script from "./ProductsDialog.vue?vue&type=script&lang=js"
export * from "./ProductsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports